import React, { Component } from "react";
import "./style.scss";

class Item extends Component {
  render() {
    const { grid, children, className = "", style = {}, onClick } = this.props;

    return (
      <li
        className={`itemComp w-100 rounded-pill px-4 mt-3 ${className}`}
        style={{ gridTemplateColumns: grid, ...style }}
        onClick={onClick?.()}
      >
        {children}
      </li>
    );
  }
}

export { Item };
